<template>
  <div class="mew-component--home-footer textDark--text">
    <div class="desktop-content d-none d-lg-block">
      <v-container class="pt-12 pb-6">
        <v-row>
          <v-col v-for="(f, fkey) in footers" :key="fkey" cols="3">
            <div class="subtitle-1 font-weight-bold mb-1">{{ f.title }}</div>
            <v-list>
              <v-list-item v-for="(d, dkey) in f.data" :key="dkey" class="px-0">
                <router-link
                  v-if="d.routerLink"
                  :to="{ name: d.routerLink, query: d.query }"
                  :class="d.class"
                >
                  {{ d.label }}
                </router-link>
                <a
                  v-if="d.link"
                  :href="d.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  :class="d.class"
                >
                  {{ d.label }}
                </a>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <div class="d-flex align-center justify-space-between mt-12">
          <div class="d-flex align-center mx-n6">
            <div class="d-flex align-center line-height-small">
              <div class="px-6 border-right">
                <a
                  class="color--inherit"
                  href="mailto:service@bingox.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {{ $t('footer.feedback') }}
                </a>
              </div>
              <div class="px-6 border-right">
                <router-link :to="{ name: ROUTES_HOME.PRIVACY_POLICY.NAME }">
                  {{ $t('footer.privacy') }}
                </router-link>
              </div>
              <div class="px-6 border-right">
                <router-link :to="{ name: ROUTES_HOME.TERMS_OF_SERVICE.NAME }">
                  {{ $t('footer.tos') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </v-container>
      <v-sheet color="textDark" class="py-2">
        <v-container>
          <div class="d-flex align-center">
            <a
              :href="`https://github.com/BingoxWallet/BingoxWallet/releases/tag/v${version}`"
              target="_blank"
              class="cyan--text text--lighten-3 ma-0"
              rel="noopener noreferrer"
              >v{{ version }}</a
            >
            <v-spacer />
            <p class="teal--text text--lighten-1 ma-0">
              {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
              
            </p>
            <v-spacer />
            <v-sheet width="150" color="transparent">
              <v-select
                v-model="select"
                append-icon="mdi-chevron-down"
                :items="languages"
                item-text="name"
                item-value="value"
                return-object
                single-line
                dark
              ></v-select>
            </v-sheet>
          </div>
        </v-container>
      </v-sheet>
    </div>

    <div class="mobile-content d-block d-lg-none">
      <v-expansion-panels accordion>
        <v-expansion-panel v-for="(mf, mfkey) in footers" :key="mfkey">
          <v-expansion-panel-header>
            <v-container>
              <v-sheet color="transparent" max-width="500px" class="mx-auto">
                <h3>{{ mf.title }}</h3>
              </v-sheet>
            </v-container>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-sheet color="transparent" max-width="500px" class="mx-auto">
                <ul>
                  <li
                    v-for="(md, mdkey) in mf.data"
                    :key="mdkey"
                    class="d-flex align-center"
                  >
                    <v-icon>mdi-menu-right</v-icon>
                    <router-link
                      v-if="md.routerLink"
                      :to="{ name: md.routerLink, query: md.query }"
                    >
                      {{ md.label }}
                    </router-link>
                    <a
                      v-if="md.link"
                      :href="md.link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ md.label }}
                    </a>
                  </li>
                </ul>
              </v-sheet>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-container class="py-12">
        <v-sheet color="transparent" max-width="500px" class="mx-auto">
          <div class="d-flex mt-10">
            <div class="d-flex align-center line-height-small mx-auto">
              <div class="px-4 px-lg-6 border-right">
                <a
                  class="color--inherit"
                  href="mailto:service@bingox.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {{ $t('footer.feedback') }}
                </a>
              </div>
              <div class="px-4 px-lg-6 border-right">
                <router-link :to="{ name: ROUTES_HOME.PRIVACY_POLICY.NAME }">
                  Privacy
                </router-link>
              </div>
              <div class="px-4 px-lg-6">
                <router-link :to="{ name: ROUTES_HOME.TERMS_OF_SERVICE.NAME }">
                  Terms
                </router-link>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-container>

      <v-sheet color="textDark" class="py-9">
        <v-container>
          <v-sheet color="transparent" max-width="500px" class="mx-auto">
            <div class="d-flex align-center justify-space-between">
              <a
                :href="`https://github.com/BingoxWallet/BingoxWallet/releases/tag/v${version}`"
                rel="noopener noreferrer"
                target="_blank"
                class="cyan--text text--lighten-3 ma-0"
                >v{{ version }}</a
              >
              <v-sheet width="150" color="transparent">
                <v-select
                  v-model="select"
                  append-icon="mdi-chevron-down"
                  :items="languages"
                  item-text="name"
                  item-value="value"
                  return-object
                  single-line
                  dark
                ></v-select>
              </v-sheet>
            </div>
            <v-sheet color="transparent" max-width="300px" class="mx-auto">
              <p class="teal--text text--lighten-1 mt-6 mb-0 text-center">
                {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
                
              </p>
            </v-sheet>
          </v-sheet>
        </v-container>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { ROUTES_HOME } from '@/core/configs/configRoutes';
import { loadLanguageAsync } from '@/main/i18n';
import handlerAnalytics from '@/modules/analytics-opt-in/handlers/handlerAnalytics.mixin';
import Telegram from '@/assets/images/icons/icon-telegram-dark.svg';

export default {
  name: 'TheDefaultFooter',
  mixins: [handlerAnalytics],
  data: () => ({
    telegramIcon: Telegram,
    // eslint-disable-next-line
    ethDonationAddress: ETH_DONATION_ADDRESS,
    // eslint-disable-next-line
    btcDonationAddress: BTC_DONATION_ADDRESS,
    version: VERSION,
    footers: [
      {
        title: 'Tools',
        data: [
          {
            label: 'Verify message',
            class: 'FooterVerifyTool',
            routerLink: 'Tools',
            query: { tool: 'verify' }
          },
          {
            label: 'Convert units',
            class: 'FooterConvertTool',
            routerLink: 'Tools',
            query: { tool: 'convert' }
          },
          {
            label: 'Generate keystore file',
            class: 'FooterKeystoreTool',
            routerLink: 'Tools',
            query: { tool: 'keystore' }
          },
          {
            label: 'Send Offline Helper',
            class: 'FooterOfflineTool',
            routerLink: 'Tools',
            query: { tool: 'offline' }
          }
        ]
      },
      {
        title: 'Service',
        data: [
          { label: 'About us', routerLink: ROUTES_HOME.ABOUT_PAGE.NAME },
          { label: 'How it works', routerLink: ROUTES_HOME.HOW_IT_WORKS.NAME },
          {
            label: 'Customer support',
            link: 'mailto:service@bingox.com'
          },
          {
            label: 'Security Policy',
            routerLink: ROUTES_HOME.SECURITY_POLICY.NAME
          },
          {
            label: 'Submit DApp',
            routerLink: ROUTES_HOME.DAPP_SUBMISSION.NAME
          }
        ]
      }
    ],
    select: 'en_US',
    languages: [
      {
        name: 'English',
        value: 'en_US',
        flag: require('@/assets/images/flags/uk.png')
      },
      {
        name: 'Russian',
        value: 'ru_RU',
        flag: require('@/assets/images/flags/russia.png')
      }
    ],
    ROUTES_HOME: ROUTES_HOME
  }),
  watch: {
    select({ value }) {
      loadLanguageAsync(value);
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.v-list-item {
  min-height: 35px;
}
.border-right {
  border-right: 1px solid black;
}
.line-height-small {
  > div {
    line-height: 11px;
  }
}
.v-expansion-panel-header {
  max-width: 524px;
  margin: 0 auto;
}
</style>

<style lang="scss">
.mew-component--home-footer {
  a {
    color: var(--v-textDark-base) !important;
  }
  .v-select__selection {
    color: #80deea !important;
    width: 100%;
    text-align: right;
  }

  .v-text-field > .v-input__control > .v-input__slot:before,
  .v-text-field > .v-input__control > .v-input__slot:after,
  .v-select.v-text-field input,
  .v-text-field__details {
    display: none;
  }

  .v-text-field .v-input__append-inner {
    margin-left: -15px;
  }

  .v-text-field,
  .v-input__slot {
    margin: 0;
    padding: 0;
  }
  .v-select .v-icon {
    color: #80deea !important;
  }

  .mobile-content {
    ul {
      li {
        padding: 0.8rem 0;
        user-select: none;
      }
    }

    .v-item-group {
      border-bottom: 1px solid rgb(224 224 224);
    }

    .v-expansion-panel-header {
      padding: 25px 0rem !important;
      //padding: 23px 24px !important;
    }

    .v-sheet,
    .v-expansion-panel:before {
      box-shadow: none !important;
    }
    .v-expansion-panel-header__icon {
      //display: none !important;
      position: absolute;
      right: 20px;
      top: 0;
      bottom: 0;
    }
  }
}
</style>
